import { render, staticRenderFns } from "./NewsMultiplePinghu.vue?vue&type=template&id=5b63633c&scoped=true&"
import script from "./NewsMultiplePinghu.vue?vue&type=script&lang=ts&"
export * from "./NewsMultiplePinghu.vue?vue&type=script&lang=ts&"
import style0 from "./NewsMultiplePinghu.vue?vue&type=style&index=0&id=5b63633c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63633c",
  null
  
)

export default component.exports